"use client"

import React, { PropsWithChildren, useEffect, useState } from 'react';
import styled from 'styled-components';

export interface IProps {}

if (typeof window !== 'undefined') {
  require('smooth-scroll')('a[href*="#"]', {
    speed: 100
  });
}
const Layout: React.FC<PropsWithChildren<IProps>> = ({ children }) => {
  return (
    <Wrapper>
      {children}
    </Wrapper>
  );
};

export default Layout;
const Wrapper = styled.div``;
